import React, { useState } from 'react';
import { MapPin, Phone, Mail, Clock, Send, User, MessageCircle } from 'lucide-react';

const ContactSection = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    collection: '',
    message: ''
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
    alert('Thank you for your inquiry! We will get back to you soon.');
    setFormData({
      name: '',
      email: '',
      collection: '',
      message: ''
    });
  };

  return (
    <section className="py-16 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-3">Visit Our Store</h2>
          <p className="text-gray-600 text-lg">Experience luxury in person</p>
          <div className="w-24 h-1 bg-[#846358] mx-auto mt-4"></div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          <div className="space-y-8">
            <div className="bg-white rounded-lg shadow-lg p-6 hover:shadow-xl transition-shadow">
              <div className="flex items-start space-x-4">
                <div className="bg-[#846358]/10 p-3 rounded-full">
                  <MapPin className="text-[#846358]" size={24} />
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-gray-800 mb-2">Our Location</h3>
                  <p className="text-gray-600 leading-relaxed">
                    NCC Tiraha, Tikhampur, Ballia,<br />
                    Uttar Pradesh 277001, India
                  </p>
                  <a 
                    href="https://maps.google.com/?q=NCC+Tiraha+Tikhampur+Ballia" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="inline-block mt-3 text-[#846358] hover:text-[#6d5348] text-sm font-medium"
                  >
                    Get Directions →
                  </a>
                </div>
              </div>
            </div>
            <div className="bg-white rounded-lg shadow-lg p-6 hover:shadow-xl transition-shadow">
              <div className="space-y-4">
                <div className="flex items-center space-x-4">
                  <div className="bg-[#846358]/10 p-3 rounded-full">
                    <Phone className="text-[#846358]" size={24} />
                  </div>
                  <div>
                    <h3 className="text-xl font-semibold text-gray-800 mb-1">Phone</h3>
                    <p className="text-gray-600"> 089537 86652</p>
                    <p className="text-gray-500 text-sm">Mon-Sat: 10:00 AM - 8:00 PM</p>
                  </div>
                </div>
                <div className="flex items-center space-x-4">
                  <div className="bg-[#846358]/10 p-3 rounded-full">
                    <Mail className="text-[#846358]" size={24} />
                  </div>
                  <div>
                    <h3 className="text-xl font-semibold text-gray-800 mb-1">Email</h3>
                    <p className="text-gray-600">info@dpjewellersballia.in</p>
                    <p className="text-gray-500 text-sm">24/7 online support</p>
                  </div>
                </div>
                <div className="flex items-center space-x-4">
                  <div className="bg-[#846358]/10 p-3 rounded-full">
                    <Clock className="text-[#846358]" size={24} />
                  </div>
                  <div>
                    <h3 className="text-xl font-semibold text-gray-800 mb-1">Opening Hours</h3>
                    <p className="text-gray-600">Monday - Saturday: 10:00 AM - 8:00 PM</p>
                    <p className="text-gray-600">Sunday: Closed</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="bg-white rounded-lg shadow-lg overflow-hidden">
              <iframe 
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3590.0!2d84.1456!3d25.7598!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMjXCsDQ1JzM1LjMiTiA4NMKwMDgnNDQuMiJF!5e0!3m2!1sen!2sin!4v1700000000000!5m2!1sen!2sin" 
                width="100%" 
                height="250" 
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                title="Store Location"
              ></iframe>
            </div>
          </div>
          <div className="bg-white rounded-lg shadow-xl p-8">
            <div className="text-center mb-8">
              <h3 className="text-2xl font-bold text-gray-800 mb-2">Send an Inquiry</h3>
              <p className="text-gray-600">We'll get back to you within 24 hours</p>
            </div>

            <form onSubmit={handleSubmit} className="space-y-6">
              <div>
                <label className="block text-gray-700 font-medium mb-2">
                  Your Name <span className="text-red-500">*</span>
                </label>
                <div className="relative">
                  <User className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={18} />
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:border-[#846358] focus:ring-2 focus:ring-[#846358]/20 transition-colors"
                    placeholder="Enter your full name"
                  />
                </div>
              </div>
              <div>
                <label className="block text-gray-700 font-medium mb-2">
                  Email Address <span className="text-red-500">*</span>
                </label>
                <div className="relative">
                  <Mail className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={18} />
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:border-[#846358] focus:ring-2 focus:ring-[#846358]/20 transition-colors"
                    placeholder="your@email.com"
                  />
                </div>
              </div>
              <div>
                <label className="block text-gray-700 font-medium mb-2">
                  Select Collection of Interest
                </label>
                <select
                  name="collection"
                  value={formData.collection}
                  onChange={handleChange}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:border-[#846358] focus:ring-2 focus:ring-[#846358]/20 transition-colors bg-white"
                >
                  <option value="">Select a collection</option>
                  <option value="gold">Gold Jewellery</option>
                  <option value="diamond">Diamond Jewellery</option>
                  <option value="silver">Silver Articles</option>
                  <option value="platinum">Platinum Collection</option>
                  <option value="gemstones">Gemstones</option>
                  <option value="necklaces">Necklaces</option>
                  <option value="rings">Rings</option>
                  <option value="earrings">Earrings</option>
                  <option value="bracelets">Bracelets</option>
                </select>
              </div>
              <div>
                <label className="block text-gray-700 font-medium mb-2">
                  Your Message
                </label>
                <div className="relative">
                  <MessageCircle className="absolute left-3 top-3 text-gray-400" size={18} />
                  <textarea
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    rows="4"
                    className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:border-[#846358] focus:ring-2 focus:ring-[#846358]/20 transition-colors resize-none"
                    placeholder="Tell us about your requirements..."
                  ></textarea>
                </div>
              </div>
              <button
                type="submit"
                className="w-full bg-[#846358] hover:bg-[#6d5348] text-white font-semibold py-3 px-6 rounded-lg transition-colors flex items-center justify-center space-x-2"
              >
                <Send size={18} />
                <span>Send Inquiry</span>
              </button>
              <p className="text-gray-500 text-xs text-center mt-4">
                We respect your privacy. Your information will not be shared.
              </p>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;